import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getAPIURL } from "helpers";
import { getBaseQueryWithRejection } from "redux/helper.redux";

const baseQueryWithRejection = getBaseQueryWithRejection(
    fetchBaseQuery({
        baseUrl: getAPIURL("/api/pvsa/common"),
        prepareHeaders: (headers, { getState }) => {
            const token = getState().auth.accessToken;
            if (token) {
                headers.set("Authorization", `Bearer ${token}`);
            }
            return headers;
        },
    })
);

export const commonApi = createApi({
    reducerPath: "commonApi",
    baseQuery: baseQueryWithRejection,
    tagTypes: [],
    endpoints: (builder) => ({
        getTempCC: builder.query({
            query: (type) => `get-temp-cc/${type}`,
            transformResponse: (response) => response.data,
            providesTags: [],
        }),
    }),
});

export const { useGetTempCCQuery, useLazyGetTempCCQuery } = commonApi;
